<ion-app style="background-color: white">
    <mat-sidenav-container>
        <mat-sidenav
            #sideMenu
            [(opened)]="shouldOpenSideMenu"
        >
            <app-side-menu-content
                (sideNavItemClickedEvent)="sideNavItemClickedEventHandler($event)"
            ></app-side-menu-content>
        </mat-sidenav>
        <mat-sidenav-content>
            <app-header
                (toggleSideMenuEvent)="toggleSideMenuEventHandler($event)"
                [sideMenuOpened]="sideMenu.opened"
            ></app-header>
            <ion-router-outlet></ion-router-outlet>
        </mat-sidenav-content>
    </mat-sidenav-container>
</ion-app>
<!-- [style.display]="isHidden?'none':'block'" -->
